export default "__VITE_ASSET__7G4VnuBI__"